<div class="widget-card" [class.clickable]="clickable" [class.status-card]="showStatusMode">
  @if (showStatusMode) {
    <div class="status-header" [ngClass]="statusColor ? 'status-' + statusColor : ''">
      @if (statusIcon) {
        <mat-icon [ngClass]="statusColor ? 'icon-' + statusColor : ''">
          {{ statusIcon }}
        </mat-icon>
      }
      <span>{{ statusName | translate }}</span>
    </div>
    <div class="status-values">
      @for (widgetBlock of statusDisplayBlocks; track $index; let isLast = $last) {
        <div
          class="status-value-block"
          [class.widget-block-clickable]="clickable && !isSingleMode"
          [matTooltip]="widgetBlock.tooltip || '' | translate"
          [matTooltipDisabled]="!widgetBlock.tooltip"
          [matTooltipMobileTap]="clickable ? 'off' : 'on'"
          (click)="onStatusBlockClick($index, widgetBlock, $event)"
        >
          <span class="widget-value">{{ widgetBlock.value ?? 'N/A' }}</span>
          @if (blockLabels[$index]) {
            <span class="status-value-label">{{ blockLabels[$index] | translate }}</span>
          }
        </div>
        @if (!isLast) {
          <div class="widget-divider"></div>
        }
      }
    </div>
  } @else {
    @for (widgetBlock of displayBlocks; track $index; let isLast = $last) {
      <div
        class="widget-block"
        [class.widget-block-clickable]="clickable && !isSingleMode"
        [matTooltip]="widgetBlock.tooltip || '' | translate"
        [matTooltipDisabled]="!widgetBlock.tooltip"
        [matTooltipMobileTap]="clickable ? 'off' : 'on'"
        (click)="onBlockClick($index, widgetBlock, $event)"
      >
        <div class="widget-content">
          <span class="widget-name">{{ widgetBlock.name | translate }}</span>
          <span class="widget-value">{{ widgetBlock.value ?? 'N/A' }}</span>
          @if (widgetBlock.description) {
            <span class="widget-description">
              @if (widgetBlock.descriptionIcon) {
                <mat-icon
                  class="description-icon"
                  [ngClass]="
                    widgetBlock.descriptionColor ? 'icon-' + widgetBlock.descriptionColor : ''
                  "
                >
                  {{ widgetBlock.descriptionIcon }}
                </mat-icon>
              }
              {{ widgetBlock.description | translate }}
            </span>
          }
        </div>
        @if (widgetBlock.icon) {
          <mat-icon class="widget-icon" [ngClass]="'icon-' + widgetBlock.iconColor">
            {{ widgetBlock.icon }}
          </mat-icon>
        }
      </div>
      @if (!isLast && !isSingleMode) {
        <div class="widget-divider"></div>
      }
    }
  }
  @if (loading) {
    <div class="loading-spinner">
      <mat-spinner diameter="20"></mat-spinner>
    </div>
  }
</div>
